import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bold-text is-overlay badge is-size-6-mobile is-size-5-tablet has-text-white has-text-centered-mobile"
}
const _hoisted_2 = {
  key: 0,
  class: "help is-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["box has-text-centered is-clickable plan-card mx-auto mb-1 py-3 px-1-mobile px-3-tablet is-relative is-clipped is-flex is-align-items-center is-justify-content-center", {'has-background-primary': _ctx.isSelected, 'has-text-white': _ctx.isSelected, 'custom-plan': _ctx.isCustomPlan}]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPlanClick && _ctx.onPlanClick(...args)))
    }, [
      (_ctx.plan.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.plan.label), 1))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.planContentComp), {
        plan: _ctx.plan,
        modelValue: _ctx.errorMessage,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.errorMessage) = $event))
      }, null, 8, ["plan", "modelValue"]))
    ], 2),
    (_ctx.errorMessage && _ctx.isSelected)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 64))
}